var map = {
	"./active.webp": 5176,
	"./cart-icons.webp": 6102,
	"./favicon.webp": 3515,
	"./icon-1.webp": 5170,
	"./icon-2.webp": 9748,
	"./icon-3.webp": 3817,
	"./icon-4.webp": 9850,
	"./icon-5.webp": 6566,
	"./icon-6.webp": 3878,
	"./image.jpg": 1738,
	"./image.webp": 203,
	"./logo.webp": 1355,
	"./molotov.webp": 307,
	"./search-icon.webp": 1588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;